import { api } from "@/api";
import { ActividadComercial } from "@/shared/types/actividad-comercial";
import { QueryConfig, QueryResult } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function getActividadComercial(id: string): Promise<ActividadComercial> {
  await sleep(1000);
  const response = await api.get(`actividades_comerciales/${id}`);
  return response.data;
}

export function useGetActividadComercialQuery(id: string, queryConfig: QueryConfig<ActividadComercial> = {}) {
  return useQuery({
    ...queryConfig,
    queryFn: async () => await getActividadComercial(id),
    queryKey: ["actividades_comerciales", id],
  })
}

export interface GetActividadComercialQueryProps {
  id: string,
  queryConfig?: QueryConfig<ActividadComercial>,
  children: (queryResult: QueryResult<ActividadComercial>) => ReactNode
}

export function GetActividadComercialQuery({
  id,
  queryConfig,
  children
}: GetActividadComercialQueryProps) {
  const queryResult = useGetActividadComercialQuery(id, queryConfig);
  return children(queryResult);
}
